// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"642e00ac","433":"9eedfd75","752":"7530bedd"}[chunkId] + ".chunk.css";
};